import { h } from "preact";
import { useState } from "preact/hooks";
import { imageUrl, srcset } from "../../../../../foundation/utils/image";
import ResponsiveImage from "../../../../../library/ResponsiveImage";
import LoginSignupTemplate from "../../LoginSignupTemplate";
import ForgotPasswordForm from "../../forms/ForgotPasswordForm";

import "./style.css";

interface Props {
    forgotPasswordParams?: {
        email?: string;
    };
}

function PasswordRequestSuccess() {
    const imageSrc = imageUrl("img/onboarding-illustration-5.png");

    return (
        <div class="passwordRequestSuccess">
            <div class="imageWrapper">
                <img src={imageSrc} srcSet={srcset(imageSrc)}/>
            </div>
            <h1>Incoming!</h1>
            <p>We just sent you an email.</p>
            <p>Please follow the instructions in the email to access your account.</p>
        </div>
    );
}

export function ForgotPasswordPage({ forgotPasswordParams }: Props) {
    const [requestSuccess, setRequestSuccess] = useState<boolean>(false);

    function handleRequestSuccess() {
        setRequestSuccess(true);
    }

    return requestSuccess ? (
        <PasswordRequestSuccess/>
    ) : (
        <LoginSignupTemplate
            illustration={<ResponsiveImage asset="img/onboarding-illustration-4.png"/>}
            displayIllustrationOnMobile={true}
            header="Forgot your password?"
            form={(
                <ForgotPasswordForm
                    forgotPasswordParams={forgotPasswordParams}
                    onRequestSuccess={handleRequestSuccess}/>
            )}/>
    );
}

export default ForgotPasswordPage;

